module.exports = __webpack_public_path__ + "media/audio10.7a20326b.mp3";